import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const assetImporterSelectors = importerSelectors(
  'asset.importer',
);

export default assetImporterSelectors;
